/**
 * ws 订阅类型
 */
export const NORMAL_SUBSCRIBE_MAP = new Map([['Ticker', 'Ticker'], ['access', 'access']])

export const WORKER_MSG_TOPIC = new Map([
  ['SUBSCRIBE', 'subscribe'],
  ['UNSUBSCRIBE', 'unsubscribe'],
  ['ACCESS', 'access'],

])
